import { createSignal, onCleanup, onMount } from "solid-js";

/**
 * Track a media query match result reactively.
 */
export function useMediaQuery(query: string) {
  const [matches, setMatches] = createSignal(false);

  onMount(() => {
    if (typeof window === "undefined") return;

    const mediaQuery = window.matchMedia(query);
    const updateMatch = (event?: MediaQueryListEvent) => {
      setMatches(event ? event.matches : mediaQuery.matches);
    };

    updateMatch();
    mediaQuery.addEventListener("change", updateMatch);
    onCleanup(() => mediaQuery.removeEventListener("change", updateMatch));
  });

  return matches;
}

